<section class="section deactivated">
  <div class="deactivated__content">
    <i class="fas fa-hand-paper deactivated__icon"></i>
    <p class="deactivated__text">Подождите, пока администратор активирует ваш аккаунт.</p>
    <a type="button" class="btn btn-danger" routerLink="/auth/logout" title="Выйти из аккаунта">Выйти</a>
  </div>
</section>
